/**
 * Enum statusów użytkownika
 *
 * @export
 * @enum {number}
 */
export var UserState;
(function (UserState) {
    UserState[UserState["NOT_CONFIRMED"] = -1] = "NOT_CONFIRMED";
    UserState[UserState["DISABLED"] = 0] = "DISABLED";
    UserState[UserState["ACTIVE"] = 1] = "ACTIVE";
})(UserState || (UserState = {}));
//# sourceMappingURL=userState.enum.js.map